// 请求参数类型

import { EServiceType } from './common';
import { TextVisitServiceType } from './textVisit';

// 退款状态枚举
export enum ETextVisitRefundStatus {
    /** Pending Review - refund request submitted, waiting for approval */
    PENDING_REVIEW = 'PENDING_REVIEW',
    /** Approve Full - approved for full refund */
    APPROVE_FULL = 'APPROVE_FULL',
    /** Approve Partial - approved for partial refund */
    APPROVE_PARTIAL = 'APPROVE_PARTIAL',
    /** Denied - approval denied */
    DENIED = 'DENIED',
    /** Auto Approved - automatically approved by system */
    AUTO_APPROVED = 'AUTO_APPROVED',
}

// 退款执行状态枚举
export enum ETextVisitRefundExecutionStatus {
    PENDING_REVIEW = 'PENDING_REVIEW',
    WAITING_REFUNDED = 'WAITING_REFUNDED',
    IN_PROGRESS = 'IN_PROGRESS',
    REFUNDED = 'REFUNDED',
    FAILED = 'FAILED',
    DENIED = 'DENIED',
}

export type TTextVisitCaseListParams = {
    patientName?: string;
    caseId?: string;
    assignProviderName?: string;
    status?: string[];
    paymentStatus?: string[];
    refundStatus?: ETextVisitRefundStatus[];
    refundReasonType?: string[];
    treatmentSubmitted?: boolean;
    condition?: string;
    state?: string;
    assessmentName?: string; // workflow name search
    sortBy?: string; // SUBMITTED_AT, LAST_MODIFIED
    sortType?: string; // ASC, DESC
    size: number;
    current: number;
    assignedProviderId?: number;
};

// 单个病例数据类型
export type TTextVisitCaseItem = {
    id: number;
    textVisitUuid: string;
    klarityUserId: number;
    patientFirstName: string;
    patientLastName: string;
    patientEmail: string;
    patientGender: string;
    patientBirthday: string;
    assignedProviderId: number | null;
    assignedProviderFirstName: string | null;
    assignedProviderLastName: string | null;
    assignedProviderPhoto: string | null;
    status: string;
    paymentStatus: string;
    refundStatus: ETextVisitRefundStatus | null;
    refundExecutionStatus: ETextVisitRefundExecutionStatus | null;
    refundAmount: number;
    refundReason: string | null;
    notesInternal: string | null;
    notesToProvider: string | null;
    notesToPatient: string | null;
    providerTreatmentSubmitted: boolean;
    state: string;
    conditions: string;
    patientSubmitAt: string;
    assignedProviderAt: string | null;
    updatedAt: string;
    closedAt: string | null;
    refundRequestId: number | null;
    assessmentName?: string; // workflow name
    serviceType?: TextVisitServiceType;
    specialty?: string;
};

// API响应数据类型
export type TTextVisitCaseListResponse = {
    code: number;
    message: string;
    data: {
        pageNo: number;
        pageSize: number;
        totalRecords: number;
        isLast: boolean;
        list: TTextVisitCaseItem[];
    };
};

export enum ETextVisitProviderListSortBy {
    IN_PROGRESS_CASES = 'IN_PROGRESS_CASES',
    ACTIVE_CASES = 'ACTIVE_CASES',
    CLOSE_CASES = 'CLOSE_CASES',
    LAST_MODIFIED = 'LAST_MODIFIED',
}

// 请求参数类型
export type TTextVisitProviderListParams = {
    name?: string;
    uidPublic?: string;
    reviewBy?: string;
    status?: string[];
    sortBy?: ETextVisitProviderListSortBy; //IN_PROGRESS_CASES  ACTIVE_CASES  CLOSE_CASES LAST_MODIFIED
    sortType?: string; //ASC DESC
    size?: number;
    current?: number;
};
//PENDING   APPROVED   REJECT   PAUSE

export enum ETextVisitProviderApproveStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECT = 'REJECT',
    PAUSE = 'PAUSE',
}

export type TTextVisitProviderItem = {
    id: number;
    providerId: number;
    status: ETextVisitProviderApproveStatus;
    firstSubmitAt: string | null;
    lastSubmitAt: string | null;
    approvedAt: string | null;
    lastRejectedAt: string | null;
    lastPausedAt: string | null;
    lastResumeAt: string | null;
    inProgressCaseQty: number;
    activeCaseQty: number;
    closedCaseQty: number;
    textVisitId: number | null;
    reviewUserId: number;
    createdAt: string | null;
    updatedAt: string;
    eligible: boolean | null;
    firstName: string;
    lastName: string;
    uid: string;
    reviewUserFirstName: string;
    reviewUserLastName: string;
};

// 病例详情 - 跟进消息类型
export type TTextVisitFollowUpDetail = {
    id: number;
    textVisitId: number;
    senderType: string;
    senderId: number;
    message: string;
    createdAt: string;
    updatedAt: string;
};

// 病例详情 - 治疗方案附件类型
export type TTextVisitTreatmentAttachment = {
    id: number;
    textVisitId: number;
    path: string;
    sort: number;
    createdBy: number;
    createdAt: string;
    updatedBy: number;
    updatedAt: string;
};

// 病例详情 - 处方药医嘱类型
export type TTextVisitPrescriptionSig = {
    id: number | null;
    prescriptionId: number | null;
    drugId: number | null;
    sigOrder: number | null;
    line3: string;
    doseDeliveryMethodText: string | null;
    doseQuantity: number | null;
    doseFormText: string | null;
    routeOfAdministrationText: string | null;
    administrationTimingText: string | null;
    frequencyNumericValue: number | null;
    frequencyUnitsText: string | null;
    descriptor: string | null;
    calculate: boolean | null;
    createdAt: string | null;
};

// 病例详情 - 处方类型
export type TTextVisitPrescriptionDetail = {
    prescriptionId: number;
    bpProviderId: number;
    bpClientId: number;
    clientFirstName: string | null;
    clientLastName: string | null;
    drugId: number;
    drugName: string;
    drugLine1: string;
    drugLine2: string;
    drugSigs: TTextVisitPrescriptionSig[];
    drugFormat: string;
    refill: number;
    duration: number;
    quantity: string;
    fillDate: string;
    approveDate: string | null;
    status: string;
    statusTypeId: number;
    writtenDate: string;
    expires: string;
    pharmacyId: number;
    pharmacyBusinessName: string;
    pharmacyAddressLine1: string;
    pharmacyAddressLine2: string;
    pharmacyCity: string;
    pharmacyState: string;
    pharmacyPostalCode: string;
    pharmacyPhone: string;
    pharmacyFax: string;
};

// 病例详情 - 治疗方案类型
export type TTextVisitTreatmentPlanDetail = {
    id: number;
    textVisitId: number;
    providerId: number;
    clientId: number;
    treatmentPlan: string;
    aiTreatmentPlan: string | null;
    aiTreatmentDraftStatus: boolean;
    autoFollowUp: boolean;
    autoFollowUpInterval: number;
    autoFollowUpIntervalUnit: string;
    autoFollowUpMessage: string;
    providerNote: string;
    createdAt: string;
    updatedAt: string;
    attachments: TTextVisitTreatmentAttachment[];
    prescriptions: TTextVisitPrescriptionDetail[] | null;
};

// 病例详情 - 问题类型
export type TTextVisitIntakeQuestionDetail = {
    id: number;
    textVisitId: number;
    questionType: string;
    fullQuestionName: string;
    shortQuestionName: string;
    answer: string;
    sort: number;
    createdAt: string;
    updatedAt: string;
};

// 病例详情 - 详情项类型
export type TTextVisitCaseDetailItem = {
    id: number;
    textVisitUuid: string;
    klarityUserId: number;
    clientId: number;
    patientFirstName: string;
    patientLastName: string;
    patientGender: string;
    patientBirthday: string;
    patientIdFrontUrl: string;
    patientIdBackUrl: string;
    state: string;
    conditions: string;
    paymentStatus: string;
    idVerified: boolean;
    patientSubmitAt: string;
    providerTreatmentSubmitted: boolean;
    status: string;
    updatedAt: string;
    assignedProviderId: number;
    assignedProviderFirstName: string;
    assignedProviderLastName: string;
    assignedProviderPhoto: string;
    assignedProviderAt: string;
    aiSummary: string;
    aiSummaryContextMd5: string;
    aiSummaryGenerateAt: string | null;
    aiTags: string;
    historyMedical: string[];
    currentMedications: string[];
    allergies: string[];
    followUps: TTextVisitFollowUpDetail[];
    treatmentPlan: TTextVisitTreatmentPlanDetail;
    intakeQuestions: TTextVisitIntakeQuestionDetail[];
    providerEligible: any | null;
    payoutAmount: number;
    serviceType: string;
    patientAdditionalComment: string;
    prescriptions: TTextVisitPrescriptionDetail[] | null;
    pharmacySelected: boolean;
};

// 病例详情 - API响应类型
export type TTextVisitCaseDetailResponse = {
    code: number;
    message: string;
    data: TTextVisitCaseDetailItem;
};
